import React from 'react';
import Homepage from './Components/Homepage'
import Navbar from './Components/Navbar'
import Pokemon from './Components/Pokemon'
import './App.css';
import Footer from './Components/Footer'
import Error from './Error'
import { Route, Switch } from 'react-router-dom'
import PokemonType from './Components/PokemonType';
function App() {
  return (
    <div className="App">
    <Navbar />
      <Switch>
        <Route exact path={'/'}><Homepage /></Route>
        <Route exact path={'/pokemon'} ><Pokemon /></Route>
        <Route path={'/pokemon/:name'}>
          <PokemonType /></Route>
        <Route path="*" component={Error} />
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
